"use client";

import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { PostsProvider, usePosts } from "@/integrations/wordpress/WordPressPostsProvider";
import { WP_Query } from "@/integrations/wordpress/wp_query";
function formatDate(dateStr?: string): string {
  if (!dateStr) return "";
  try {
    const d = new Date(dateStr);
    return d.toLocaleDateString("en-US", {
      month: "long",
      year: "numeric"
    }).toUpperCase();
  } catch {
    return "";
  }
}
function stripHtml(html?: string): string {
  if (!html) return "";
  return html.replace(/<[^>]*>/g, "").replace(/\s+/g, " ").trim();
}
function FeaturedStoriesConsumer() {
  const {
    posts,
    loading,
    error
  } = usePosts();
  if (loading) {
    return <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-12">
        {[0, 1, 2].map(i => <div key={i} data-index={i} className="flex flex-col h-full">
            <div className="aspect-[4/5] w-full bg-muted/40" />
            <div className="mt-6 h-3 w-40 bg-muted/40" />
            <div className="mt-4 h-7 w-3/4 bg-muted/40" />
            <div className="mt-4 h-4 w-full bg-muted/30" />
            <div className="mt-2 h-4 w-5/6 bg-muted/30" />
          </div>)}
      </div>;
  }
  if (error) {
    return <p className="font-default text-base text-muted-foreground">
        Unable to load articles at this moment.
      </p>;
  }
  if (!posts || posts.length === 0) {
    return <p className="font-default text-base text-muted-foreground">
        New project insights are being prepared. Please check back soon.
      </p>;
  }
  const displayPosts = posts.slice(0, 3);
  return <div className="grid grid-cols-1 gap-12 md:grid-cols-3 md:gap-12">
      {displayPosts.map((post, i) => {
      const dateLabel = formatDate(post.date);
      const categoryLabel = post.categories && post.categories.length > 0 ? post.categories[0].name.toUpperCase() : "PROJECT INSIGHT";
      const excerpt = stripHtml(post.excerpt);
      return <article data-index={i} key={post.id} className="group flex h-full flex-col">
            <div className="flex-shrink-0">
              <Link to={post.link || "#"} className="block overflow-hidden">
                <div className="aspect-[4/5] w-full overflow-hidden bg-muted">
                  {post.featuredImage ? <img src={post.featuredImage} alt={post.title} loading="lazy" decoding="async" className="h-full w-full object-cover transition-transform duration-[1200ms] ease-out group-hover:scale-105" /> : <div className="h-full w-full bg-gradient-to-br from-muted to-accent" />}
                </div>
              </Link>
            </div>

            <div className="mt-7 flex flex-1 flex-col">
              <p className="font-default text-[11px] tracking-[0.2em] text-primary" style={{
            letterSpacing: "0.2em"
          }}>
                {dateLabel}
                {dateLabel && categoryLabel ? "  ·  " : ""}
                {categoryLabel}
              </p>

              <div className="flex flex-1 flex-col">
                <h3 className="mt-5 min-h-[4rem] font-default text-[28px] leading-[1.15] text-foreground" style={{
              fontWeight: 600
            }}>
                  <Link to={post.link || "#"} className="transition-colors duration-300 hover:text-primary">
                    {post.title}
                  </Link>
                </h3>

                {excerpt && <p className="mt-4 flex-1 line-clamp-2 font-default text-base leading-relaxed text-muted-foreground">
                    {excerpt}
                  </p>}
              </div>

              <Link to={post.link || "#"} className="group/link mt-6 inline-flex items-center gap-2 font-default text-sm text-foreground">
              </Link>
            </div>
          </article>;
    })}
    </div>;
}
export default function LatestExteriorTips() {
  const wp_query_params = {
    post_type: "post",
    per_page: 3,
    order: "desc",
    orderby: "date"
  };
  const wp_query = new WP_Query(wp_query_params);
  return <section data-section-id="376" id="latest-exterior-tips" className="dark bg-background ![padding:65px_0px_65px_0px]">
      <div className="mx-auto w-full max-w-7xl px-6 md:px-10 lg:px-16">
        <div className="flex flex-col items-start justify-between gap-8 md:flex-row md:items-end">
          <div className="max-w-3xl">
            <p className="font-default text-[11px] text-primary" style={{
            letterSpacing: "0.25em"
          }}>
              EXPERT KNOWLEDGE — INDUSTRY INSIGHTS
            </p>
            <h2 className="mt-6 font-default text-5xl leading-[1.05] text-foreground md:text-6xl lg:text-[64px]" style={{
            fontWeight: 600
          }}>
              Latest <em className="italic text-primary">exterior</em> tips.
            </h2>
          </div>

          <Link to="/ContactPage" className="group inline-flex shrink-0 items-center gap-2 font-default text-sm text-foreground">
            
            
          </Link>
        </div>

        <div className="mt-20 md:mt-24">
          <PostsProvider wp_query={{
          post_type: "post",
          per_page: 3,
          order: "desc",
          orderby: "date"
        }}>
            <FeaturedStoriesConsumer />
          </PostsProvider>
        </div>
      </div>
    </section>;
}